module.exports = __webpack_public_path__ + "img/guide-scan@3x.44713326.jpg";